import React from 'react';
import { Done as DoneIcon, PriorityHigh as PriorityHighIcon } from '@mui/icons-material';

import { Loader } from './Loader';

import './ModalCompletionFormIcon.css';

export const ModalCompletionFormIcon = ({ isConfirmed, loading }) => {
  if (loading) {
    return (
      <div className="loader-icon-wrapper">
        {' '}
        <Loader size={12} />
      </div>
    );
  }

  if (isConfirmed) {
    return (
      <div className="done-icon-wrapper">
        {' '}
        <DoneIcon sx={{ fontSize: 'medium', color: 'white' }} fontSize="s" height="10" />{' '}
      </div>
    );
  }

  return (
    <div className="high-priority-icon-wrapper">
      {' '}
      <PriorityHighIcon fontSize="s" height="10" />{' '}
    </div>
  );
};
